import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { styled } from '@mui/material/styles';
import { ModalBase } from '@components/Modal';
import { useTranslation } from '@hooks';
import { RoutePath } from '@constants/routes';
import { BILLING_TYPE_MAP } from '@constants/billing';
import Paywall from '.';

const Modal = styled(ModalBase)({
    '& .modal-base-paper': {
        outline: 'none',
        width: 'calc(100% - 32px)',
        height: 'calc(var(--100vh) - 32px)',
        '@media (max-width: 900px)': {
            height: 'var(--100vh)',
            width: '100%',
            borderRadius: 0,
        },
    },
    '& .modal-base-content': {
        padding: 24,
    },
    '& .MuiBackdrop-root': {
        left: 'var(--sidebar-width)',
    },
});

const ModalHeaderMap = {
    [RoutePath.SurveysResponses]: 'surveys',
    [RoutePath.SurveysTemplates]: 'surveys',
    [RoutePath.SurveysAnalyticsConversion]: 'surveys',
    [RoutePath.SurveysAnalyticsResponses]: 'surveys',
    [RoutePath.SurveysAnalyticsSurveyInsights]: 'surveys',
    [RoutePath.ReviewsAutomationAutoReplies]: 'reviewsAutomation',
    [RoutePath.ReviewsAutomationReplyTemplates]: 'reviewsAutomation',
    [RoutePath.CampaignsAutomated]: 'campaigns',
    [RoutePath.CampaignsOneTime]: 'campaigns',
    [RoutePath.Coupons]: 'coupons',
};

const TryForFreeModal = () => {
    const account = useSelector(state => state.account?.account);
    const { t } = useTranslation();
    const { pathname } = useLocation();

    const isAllowedPath = Object.keys(ModalHeaderMap).includes(pathname);
    const currentGroup = isAllowedPath ? ModalHeaderMap[pathname] : null;

    const getTryForFreeLsState = () => {
        const stored = localStorage.getItem('tryForFreeModal');
        if (!stored) return {};
        try {
            return JSON.parse(stored);
        } catch {
            return {};
        }
    };

    const tryForFreeLsState = getTryForFreeLsState();
    const hasGroupBeenShown = currentGroup ? tryForFreeLsState[currentGroup] === true : false;
    const [isTryForFreeModalOpen, setIsTryForFreeModalOpen] = useState(!hasGroupBeenShown);

    useEffect(() => {
        if (currentGroup) {
            const updatedTryForFreeLsState = getTryForFreeLsState();
            const hasGroupBeenShown = updatedTryForFreeLsState[currentGroup] === true;
            setIsTryForFreeModalOpen(!hasGroupBeenShown);
        }
    }, [pathname, currentGroup]);

    const handleCloseTryForFreeModal = () => {
        if (currentGroup) {
            const updatedState = {
                ...tryForFreeLsState,
                [currentGroup]: true,
            };
            localStorage.setItem('tryForFreeModal', JSON.stringify(updatedState));
        }
        setIsTryForFreeModalOpen(false);
    };

    const subscription = account?.subscriptions[0];
    const isTrialPlan = subscription?.billingPlanName === BILLING_TYPE_MAP.TRIAL;

    if (!isTrialPlan || !isAllowedPath) return null;

    return (
        <Modal isOpen={isTryForFreeModalOpen} handleClose={null} title={t(`Header.${ModalHeaderMap[pathname]}`)}>
            <Paywall onTryForFreeClick={handleCloseTryForFreeModal} />
        </Modal>
    );
};

export default TryForFreeModal;
